import type { ComponentProps } from 'react';
import { OwcPagination } from '@one/react';

export type PocPaginationProps = ComponentProps<typeof OwcPagination>;

export const PocPagination: React.FC<PocPaginationProps> = (props) => <OwcPagination {...props} />;
